import { connectRouter } from 'connected-react-router';
import { combineReducers } from 'redux';
import AuthReducer from './Auth';
import DrawerReducer from './Drawer';
import ModalReducer from './Modal';
import OfferReducer from './Offer';
import BuyerReducer from './Buyer';
import PreDealsReducer from './PreDeals';
import EntitiesReducer from './Entities';
import AssetsReducer from './Assets';

export default (history) =>
  combineReducers({
    router: connectRouter(history),
    AuthReducer,
    ModalReducer,
    DrawerReducer,
    OfferReducer,
    BuyerReducer,
    PreDealsReducer,
    EntitiesReducer,
    AssetsReducer,
  });
